import React, {useState, useEffect, useContext} from "react";
import DetailsComponent from "./DetailsComponent";
import {CardCoach, CardWhiteCoach, ActionBio} from "./FacilitadorStyle";
import {TypeTitle, TextDescription, ContentContainer} from "../../../styles/Products";
import Color from "../../../assets/Colors";
import {
   SectionDetail,
   InfoDetail,
   TitleContainer,
   SectionWithSubtitle,
   TitleSection,
   SubtitleContainer,
   TextDetail,
   FullExpe,
} from "./Styles";
import {Content} from "../../../styles/GlobalStyles";
import {CoursesContext} from "../../../context/CoursesContext";
import {useParams, useLocation} from "react-router-dom";
import {LoadComponet} from "../../../components/loaders/Loader";
import VideoModal from "../../modals/VideoModal";
import {Link} from "react-router-dom";

export default function ExperienceSection({icon, text, title, image, image2, link}) {
   const {getExperiencesList, testimonialsList} = useContext(CoursesContext);
   const [isMobile, setMobile] = useState(false);
   let {id} = useParams();
   let location = useLocation();

   useEffect(() => {
      setMobile(window.screen.width <= 500);
   }, []);

   useEffect(() => {
      getExperiencesList(id);
   }, [id]);

   if (testimonialsList.isLoading) return <LoadComponet />;

   if (isMobile) {
      return (
         <DetailsComponent title="" iconTitle="" full={true}>
            <Content>
               <ContentContainer>
                  {React.Children.toArray(
                     testimonialsList.data.map((testi) => {
                        return (
                           <CardCoach
                              isFully={testimonialsList.data.length === 1}
                              as={Link}
                              to={`${location.pathname}?video${testi.idTestimonial}=true`}
                           >
                              <img src={`http://domecqapi.trebolbit.com/${testi.pathImage}`} alt="experience" className="profileImg" />
                              {testimonialsList.data.length === 1 && (
                                 <CardWhiteCoach>
                                    {icon && <img src={icon} className="iconDot" alt="dot" />}
                                    <TypeTitle color={Color.primary}>{testi.title}</TypeTitle>
                                    <TextDescription>{testi.longDescription}</TextDescription>
                                    <ActionBio as="div">
                                       <span>Ver video</span>
                                       <img src={require("../../../assets/icons/media.png")} alt="next" className="mediaIcon" />
                                    </ActionBio>
                                 </CardWhiteCoach>
                              )}
                              <VideoModal videoUrl={testi.pathVideo} initiator={`video${testi.idTestimonial}`} />
                           </CardCoach>
                        );
                     }),
                  )}
               </ContentContainer>
            </Content>
         </DetailsComponent>
      );
   }
   return (
      <DetailsComponent title="" iconTitle="" full={false}>
         <Content>
            <Content style={{marginBottom: "2em"}}>
               <SectionWithSubtitle style={{marginBottom: "2em"}}>
                  <TitleContainer>
                     <img src={require("../../../assets/icons/happy-ligth.png")} alt="experiencia" className="titleIcon" />
                     <TitleSection>
                        Mi experiencia en <br />
                        domecq academy
                     </TitleSection>
                  </TitleContainer>
                  <SubtitleContainer>
                     <TextDetail style={{marginTop: "1em"}}>
                        Te invitamos a conocer lo que opinan nuestros agresados y a escuchar de viva voz como Domecq Academy los ha ayudado
                        a impulsar su desarrollo profesional
                     </TextDetail>
                  </SubtitleContainer>
               </SectionWithSubtitle>
            </Content>
            <ContentContainer>
               {React.Children.toArray(
                  testimonialsList.data.map((testi) => {
                     return (
                        <CardCoach
                           as={Link}
                           isfully={testimonialsList.data.length === 1}
                           to={`${location.pathname}?video${testi.idTestimonial}=true`}
                        >
                           <img src={`http://domecqapi.trebolbit.com/${testi.pathImage}`} alt="experience" className="profileImg" />
                           {testimonialsList.data.length === 1 && (
                              <CardWhiteCoach>
                                 {icon && <img src={icon} className="iconDot" alt="dot" />}
                                 <TypeTitle color={Color.primary}>{testi.title}</TypeTitle>
                                 <TextDescription>{testi.longDescription}</TextDescription>
                                 <ActionBio as="div">
                                    <span>Ver video</span>
                                    <img src={require("../../../assets/icons/media.png")} alt="next" className="mediaIcon" />
                                 </ActionBio>
                              </CardWhiteCoach>
                           )}
                           <VideoModal videoUrl={testi.pathVideo} initiator={`video${testi.idTestimonial}`} />
                        </CardCoach>
                     );
                  }),
               )}
            </ContentContainer>
         </Content>
      </DetailsComponent>
   );
}
// title: Mi experiencia en domecq academy
// text: Te invitamos a conocer lo que opinan nuestros agresados y a escuchar de viva voz como Domecq Academy los ha ayudado a impulsar su desarrollo profesional

ExperienceSection.defaultProps = {
   icon: require("../../../assets/icons/happy.png"),
   image: "",
   image2: "",
   title: "Mi experiencia en domecq academy",
   link: "/media/01",
   text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tincidunt risus at fermentum suscipit. Pellentesque ipsum libero, mattis at fringilla vitae",
};

export function ExperienceFull() {
   const {getExperiencesList, testimonialsList} = useContext(CoursesContext);
   // const [isMobile, setMobile] = useState(false);
   let {id} = useParams();

   /* useEffect(() => {
      setMobile(window.screen.width <= 500);
   }, []); */

   useEffect(() => {
      getExperiencesList(id);
   }, [id]);

   if (testimonialsList.isLoading) return <LoadComponet />;
   return (
      <SectionDetail full={true} column={true}>
         <Content>
            <SectionWithSubtitle>
               <TitleContainer>
                  <img src={require("../../../assets/icons/happy-ligth.png")} alt="experiencia" className="titleIcon" />
                  <TitleSection>
                     Mi experiencia en <br />
                     domecq academy
                  </TitleSection>
               </TitleContainer>
               <SubtitleContainer>
                  <TextDetail>
                     Te invitamos a conocer lo que opinan nuestros agresados y a escuchar de viva voz como Domecq Academy los ha ayudado a
                     impulsar su desarrollo profesional
                  </TextDetail>
               </SubtitleContainer>
            </SectionWithSubtitle>
         </Content>
         <InfoDetail full={true}>
            {React.Children.toArray(
               testimonialsList.data.map((item) => {
                  return <FullExpe />;
               }),
            )}
         </InfoDetail>
      </SectionDetail>
   );
}
